import React from 'react'
import { connect } from 'react-redux'
import {
  LOGOUT
} from '../../constants/actionTypes'
import agent from '../../agent';

const mapStateToProps = state => ({
  ...state.settings,
  currentUser: state.common.currentUser
})

const mapDispatchToProps = dispatch => ({
  onClickLogout: () => dispatch({ type: LOGOUT, payload: agent.Auth.logout() })
})

class LogoutPane extends React.Component {
  render() {
    if (!this.props.currentUser) {
      return null
    }
    return (
      <button className="buttonLogout" onClick={this.props.onClickLogout}>
        Logout
      </button>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPane)



// WEBPACK FOOTER //
// ./src/components/widgets/LogoutPane.js